<div class="wm-m-browserchooser">
  <div class="wm-m-browserchooser-browsers">
    @if (getBrowserArchetypes().length === 0) {
      <div class="no-browsers">No compatible browsers found</div>
    }
    @for (archetype of getBrowserArchetypes(); track archetype) {
      <div>
        <div class="wm-m-browserchooser-browser" attr.data-testing-id="newCBT-{{archetype}}-browser">
          <div class="wm-m-browserchooser-archetype {{style}}" [ngClass]="{'selected': archetype === selectedArchetype, 'simple': simpleMode}" (click)="selectArchetype(archetype)">
            @if (browserLogos[archetype]) {
              <img class="wm-m-browserchooser-archetype-icon" [src]="browserLogos[archetype]">
            }
            @if (showDeployed && isVersionDeployed(archetype, selectedBrowserByArchetype[archetype].platform.getFullName(), selectedBrowserByArchetype[archetype].version, selectedBrowserByArchetype[archetype].model)) {
              <div class="wm-m-browserchooser-archetype-deployed">
                <fa-icon icon="tv" pTooltip="A suitable device for this browser is already deployed"></fa-icon>
              </div>
            }
          </div>
          @if (!simpleMode && selectedBrowserByArchetype[archetype]) {
            <div class="wm-m-browserchooser-selected-version {{style}}" attr.data-testing-id="wm-m-browserchooser-{{archetype}}-desktop"
              [ngClass]="{'selected': detailsShown && archetype === selectedArchetype}" (click)="toggleDetails(archetype)" pTooltip="Change OS and Version" tooltipPosition="bottom">
              <div>
                <div class="version">
                  <label>Version:</label><strong>{{selectedBrowserByArchetype[archetype].version}}</strong>
                </div>
                <div class="wm-m-browserchooser-selected-version-platform">
                  @if (platformLogos[selectedBrowserByArchetype[archetype].platform.getFullName()]) {
                    <img class="wm-m-browserchooser-platform-icon" [src]="platformLogos[selectedBrowserByArchetype[archetype].platform.getFullName()]">
                  }
                  {{selectedBrowserByArchetype[archetype].platform.platformVersion}}<br>
                </div>
                @if (!detailsShown || archetype !== selectedArchetype) {
                  <fa-icon icon="caret-down"></fa-icon>
                }
              </div>
            </div>
          }
          @if (detailsShown && archetype === selectedArchetype) {
            <div class="wm-m-browserchooser-placeholder shown {{style}}}}">
              <div class="force-overflow {{style}}"></div>
            </div>
          }
        </div>
        @if (detailsShown && archetype !== selectedArchetype) {
          <div class="wm-m-browserchooser-placeholder {{style}}"></div>
        }
      </div>
    }
  </div>
  @if (detailsShown) {
    <div class="wm-m-browserchooser-details {{style}}">
      @if (needsModel()) {
        <div>
          <div class="wm-m-browserchooser-detail-heading">Select a model:</div>
          <div class="wm-m-browserchooser-divider"></div>
          @for (model of getModelsForArchetype(selectedArchetype, true); track model) {
            <div (click)="selectModel(model)" class="wm-m-browserchooser-platform {{style}}" [ngClass]="{'selected': model == selectedModel}">
              @if (modelLogos[model]) {
                <img class="wm-m-browserchooser-platform-icon" [src]="modelLogos[model]">
                }<br>
                {{getNiceModelName(model)}}
                @if (showDeployed) {
                  <div class="wm-m-browserchooser-platform-deployed">
                    @if (isPlatformDeployed(selectedArchetype, model)) {
                      <fa-icon icon="tv" pTooltip="A suitable device for this browser is already deployed"></fa-icon>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
        <div class="wm-m-browserchooser-detail-heading">Select a platform:</div>
        <div class="wm-m-browserchooser-divider"></div>
        @for (os of getPlatformsForArchetypeAndModel(selectedArchetype, selectedModel, true); track os) {
          <div (click)="clickPlatform(os)" class="wm-m-browserchooser-platform {{style}}" [ngClass]="{'selected': os === selectedPlatform}">
            @if (platformLogos[os]) {
              <img class="wm-m-browserchooser-platform-icon" [src]="platformLogos[os]">
              }<br>
              {{cropPlatform(os)}}
              @if (showDeployed) {
                <div class="wm-m-browserchooser-platform-deployed">
                  @if (isPlatformDeployed(selectedArchetype, os)) {
                    <fa-icon icon="tv" pTooltip="A suitable device for this browser is already deployed"></fa-icon>
                  }
                </div>
              }
            </div>
          }
          <div class="wm-m-browserchooser-detail-heading">Select a browser version:</div>
          <div class="wm-m-browserchooser-divider"></div>
          @if (selectedPlatform) {
            <div class="wm-m-browserchooser-versions">
              @for (version of getVersionsForArchetypeModelAndPlatform(selectedArchetype, selectedModel, selectedPlatform); track version) {
                <div (click)="clickVersion(version)" class="wm-m-browserchooser-version {{style}}"
                  attr.data-testing-id="browserchooser-version-{{version}}"
                  [ngClass]="{'selected': selectedVersion === version}">
                  {{version}}
                  @if (showDeployed) {
                    <div class="wm-m-browserchooser-version-deployed">
                      @if (isVersionDeployed(selectedArchetype, selectedPlatform, version)) {
                        <fa-icon icon="tv" [pTooltip]="'A suitable device for this browser is already deployed'" [tooltipZIndex]="'100000'" tooltipPosition="bottom"></fa-icon>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
